<template>
  <b-card class="add-media-card add-media-card-doom-yoga w-100"
   align="center" no-body>
    <b-card-body align="center">
      <b-row align-v="center" class="h-100">
        <b-col>
          <h2 class="add-media-icon">
            <font-awesome-icon
              icon="fa-solid fa-add"
              size="md"
              class="align-middle"
            />
          </h2>
          <h2 class="add-media-text">Add New</h2>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  name: "AddMedia",
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/media_components/media/AddMediaCard.vue